import React from 'react';

/** @param {{ title: string, description: string,  image: string, github?: string, demo?: string, imageStyle?: string }} props */
const ProjectCard = ({ title, description, image, github, demo, imageStyle }) => {
  return (
    <div className="bg-[#1C1D20] p-8 rounded-2xl hover:bg-[#2A2B2F] transition-colors duration-300 cursor-pointer">
      <img src={image} alt={title} className="w-full h-64 max-h-64 object-contain rounded-xl mx-auto "/>
      <h3 className="text-2xl font-semibold text-white mb-1">{title}</h3>
      <p className="text-gray-400">{description}</p>
      <div className="flex space-x-4 mt-4">
        {demo && (
          <a
            href={demo}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 transition text-sm"
          >
            Live Demo
          </a>
        )}
        {github && (
          <a
            href={github}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gray-600 text-white px-3 py-1 rounded hover:bg-gray-700 transition text-sm"
          >
            GitHub
          </a>
        )}
      </div>
    </div>
  );
};

export default ProjectCard;
